import { browserConstants } from '../constants/actionTypes'
let initialState = { outdatedBrowser: false, displayNotification: true }

export const browser = (state = initialState, action) => {
  switch (action.type) {
    case browserConstants.SET_BROWSER:
      return {
        ...state,
        outdatedBrowser: action.payload,
      }
    case browserConstants.DISPLAY_NOTIFICATION:
      return {
        ...state,
        displayNotification: action.payload,
      }
    default:
      return state
  }
}
